import { ActivatedRouteSnapshot } from '@angular/router';
import { tap } from "rxjs/operators";
import { LoaderService } from '../../common/services/loader.service';
import { Injectable } from '@angular/core';
import { EntityBuilderService } from '../../builder/services/entity-builder.service';

@Injectable()
export class EntityResolver  {

    constructor(public ebService: EntityBuilderService, public loaderService: LoaderService) { }

    resolve(route: ActivatedRouteSnapshot) {
        this.loaderService.toggleLoader(true);
        return this.ebService.get(route.paramMap.get('id')).pipe(tap((data) => { this.loaderService.toggleLoader(false); }));
    }
}
